module.exports = __webpack_public_path__ + "img/disperse-icon-03.82aac5d7.png";